<template>
  <footer>
    <div class="bg-black">
      <div class="container pt-3">
        <div class="row">
          <div class="col-lg-6 text-white">
            <h4
              class="text-white handwritten inlineblock nomargin sameline border-bottom-big pb-2 pt-3"
            >
              Over Koemans
            </h4>
            <p>
              Koemans Vastgoed is een vastgoedonderneming actief in de regio Den
              Haag. Wij kopen panden aan met als doel deze zelf te verhuren aan
              ondernemers en bedrijven.
            </p>
            <p>
              Wij richten ons uitsluitend op ons eigen vastgoed en bouwen aan
              langdurige huurrelaties met betrouwbare huurders. Transparantie,
              service en degelijkheid staan bij ons centraal.
            </p>
          </div>

          <div class="col-lg-3">
            <h4
              class="text-white handwritten inlineblock nomargin sameline border-bottom-big pb-2 pt-3"
            >
              Bedrijfsgegevens
            </h4>
            <p class="m-0 text-white">KvK-nummer: 27363847</p>
          </div>

          <div class="col-lg-3">
            <h4
              class="text-white handwritten inlineblock nomargin sameline border-bottom-big pb-2 pt-3"
            >
              Contact
            </h4>

            <p class="m-0">
              <a
                href="mailto:info@koemansvastgoed.nl"
                class="d-inline-flex align-items-center text-white text-decoration-none"
              >
                <i class="bi bi-envelope me-2" aria-hidden="true"></i>
                <span class="visually-hidden">Email: </span>
                <span>info@koemansvastgoed.nl</span>
              </a>
            </p>
            <p class="m-0 d-flex align-items-center text-white">
              <i class="bi bi-telephone me-2" aria-hidden="true"></i>
              <span class="d-flex flex-column">
                <a
                  href="tel:+31620610656"
                  class="text-white text-decoration-none"
                >
                  Nico – +31 6 206 106 56
                </a>
                <a
                  href="tel:+31701234567"
                  class="text-white text-decoration-none"
                >
                  Ton – +31 6 546 169 99
                </a>
              </span>
            </p>

            <div class="text-white mt-3 mb-2">
              <a
                href="mailto:info@koemansvastgoed.nl"
                class="form-control btn btn-outline-primary btn-lg w-100 text-primary text-start d-flex justify-content-between align-items-center"
              >
                <span>Mail ons</span>
                <span>→</span>
              </a>
            </div>

            <div class="text-white mt-3 mb-2">
              <a
                href="tel:+31620610656"
                class="form-control btn btn-outline-primary btn-lg w-100 text-primary text-start d-flex justify-content-between align-items-center"
              >
                <span>Bel ons</span>
                <span>→</span>
              </a>
            </div>
          </div>
        </div>

        <br />
        <p class="lichtgrijstext marope text-center small text-white">
          © {{ currentYear }} Koemans Vastgoed<br />
          {{ $t("footer.rights") }}<br />
          {{ $t("footer.designBy") }}
          <a
            class="text__white"
            href="https://www.linkedin.com/company/koemans-digital-solutions"
          >
            <u>Koemans Digital Solutions </u>
          </a>
        </p>

        <p class="lichtgrijstext marope text-center small text-white m-0 pb-3">
          <a class="text-white" href="#">{{ $t("footer.nav.home") }}</a>
        </p>
      </div>
    </div>
  </footer>

  <ContactModal v-if="showContactModal" @close="showContactModal = false" />
</template>

<script>
export default {
  name: "FooterComponent",
  data() {
    return {
      currentYear: new Date().getFullYear(),
      showContactModal: false,
    };
  },
};
</script>

<style scoped>
.btn-outline-primary:hover {
  color: #ffffff !important;
}

.map-container {
  width: 100%;
  height: 350px;
}

.map-container iframe {
  width: 100%;
  height: 100%;
  border: 0;
}
</style>
